import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>A Passive Aggressive stance is rarely effective, because it
                                                allows neither open discussion nor explanation. The three
                                                other stances in the model, however, are effective in
                                                different circumstances.</p>
                                            <p>For example, where there is a need to concede one's interests
                                                in light of another's, or when the issue
                                                is of low importance to you but high importance to another,
                                                then an Accepting stance is the most constructive (if you
                                                fight the point as a matter of principle, whether you care
                                                about the outcome or not, then you'll get a reputation for
                                                being a pain in the neck in no time, and diminish your
                                                effectiveness on
                                                other occasions, when something really does matter to
                                                you). </p>
                                            <p>Or, when the issue is of extreme importance and not
                                                negotiable (matters of health and safety, risk or
                                                harassment, for example) then a Directive Confrontation
                                                stance is reasonable. In most other situations where you
                                                need to be assertive, a Constructive Challenge stance is
                                                appropriate, because you come
                                                across as wishing to communicate your views and feelings,
                                                yet open minded and receptive. </p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">What's stopping you?</div>
                                                <div className="paraspace"><p
                                                    style={{paddingBottom:'8px!important'}}>If we know we
                                                    should challenge something or someone, why do we find it
                                                    so difficult? </p></div>
                                                <ul className="greenbullet-list uiheading">
                                                    <li><p>We worry about the other person's reaction and
                                                        our ability to manage it.</p></li>
                                                    <li><p>We're unsure of our right to challenge
                                                        someone.</p></li>
                                                    <li className="cntareap"><p>We're worried about what
                                                        people will think, or that we will not be liked if
                                                        we
                                                        challenge someone.</p></li>
                                                </ul>

                                            </div>
                                            <p>Then, thinking about these possibilities makes us even more
                                                anxious and less inclined to question
                                                anything we disagree with or that affects us adversely.
                                                Instead, try to remember the following: </p>

                                            <ul className="greenbullet-list">
                                                <li>Our assumptions about another's reactions are generally
                                                    overestimated, or just wrong. Often,
                                                    whatever's worrying us is less important or hasn't even
                                                    occurred to the other person and, if
                                                    you approach a situation diplomatically, there's no
                                                    reason why you shouldn't be listened to. If
                                                    someone does react negatively, then just remain calm and
                                                    composed while you clarify
                                                    whatever point you wish to make - you'll find you can
                                                    still reach a positive outcome, even if it
                                                    takes a little longer and more than one conversation.
                                                </li>
                                                <li>Often, for reasons of upbringing, cultural background
                                                    and interpretation of social expectations
                                                    we question or deny even our fundamental beliefs.
                                                    Remember that you have the right to:<a
                                                        className="superscripttext"
                                                        href="further_info.php?course=300"><sup>2</sup></a>

                                                    <div className="innerlist"><span
                                                        className="span">—</span> Make mistakes<br/>
                                                        <span className="span">—</span> Say 'no' without
                                                        feeling guilty <br/>
                                                        <span className="span">—</span> Maintain your own
                                                        view or perspective <br/>
                                                        <span className="span">—</span> Protest against
                                                        unfair treatment or criticism <br/>
                                                        <span className="span">—</span> Not always worry
                                                        about the goodwill of others <br/>
                                                        <span className="span">—</span> Be your own judge
                                                        about the legitimacy of your feelings.
                                                    </div>
                                                </li>
                                                <li>As long as our challenge is justified and we adopt a
                                                    reasonable, moderate attitude, there is
                                                    no reason why people should think badly of us. In fact,
                                                    the opposite is more likely, because
                                                    people usually respect someone who is prepared to 'stand
                                                    up for their views'. Also, we
                                                    forget that other people's opinions of us are based on
                                                    more than a single incident. As your
                                                    mum might say:
                                                    <div
                                                        className="lightgreencontentbg lightbgcenter subtiltereg">'The
                                                        people that mind don't matter and the people that
                                                        matter don't mind!' </div>
                                                </li>
                                                <li>Remember, it might take a bit of courage to challenge
                                                    someone, but saying nothing often
                                                    makes things worse and for longer than the time and
                                                    effort needed to speak up.
                                                    <div
                                                        className="lightgreencontentbg lightbgcenter subtiltereg">Take
                                                        the plunge and make that challenge! </div>
                                                </li>

                                            </ul>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}